/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2023 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import Notify from "@eisinc/App/Components/Notify";
import { checkAddressUpdate } from "@eisinc/App/Services/CustomerAddressUpdateService";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { useContext, useEffect, useState } from "react";
import * as React from "react";

export interface CustomerAddressUpdateStyles {}

export const CustomerAddressUpdateStyles: CustomerAddressUpdateStyles = {};

const styles = CustomerAddressUpdateStyles;

const CustomerAddressUpdate: React.FunctionComponent = () => {
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [tokenResponse, setTokenResponse] = useState<boolean>(false);
    let queryParameters;

    if (typeof window !== "undefined") {
        queryParameters = new URLSearchParams(window.location.search);
    }

    const tokenParameter = queryParameters?.get("token");
    const tokenObj = {
        Token: tokenParameter,
    };

    useEffect(() => {
        if (!tokenResponse) {
            checkAddressUpdate(tokenObj).then(
                (response: any) => {
                    if (response.successful) {
                        setIsLoading(false);
                        setTokenResponse(true);
                    } else {
                        setTokenResponse(false);
                        setIsLoading(false);
                    }
                },
                (error: any) => {},
            );
        }
    }, []);

    return (
        <LoadingOverlay loading={isLoading}>
            <StyledWrapper>
                {tokenResponse ? (
                    <Notify
                        messageType="success"
                        body={siteMessage("customer_address_update_success", "Address update has been successfully requested")}
                    />
                ) : (
                    <Notify
                        messageType="danger"
                        body={siteMessage("customer_address_update_fail", "Unable to request update address, please contant our custome support")}
                    />
                )}
            </StyledWrapper>
        </LoadingOverlay>
    );
};

const widgetModule: WidgetModule = {
    component: CustomerAddressUpdate,
    definition: {
        group: "Xngage Custom" as any,
    },
};

export default widgetModule;
